import axios from 'axios'

import { consents_path } from 'routes'

export default {
  async save({ analytics, marketing, choice, url }) {
    const { data } = await axios.post(consents_path(), { analytics, marketing, choice, url })

    return data
  }
}
